var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 67,
    viewBox: "0 0 72 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 67,
    rx: 17.1501,
    fill: "#F7F6F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9184_6951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.248 33.6187C43.7093 33.6187 45.7108 35.6203 45.7109 38.0815C45.7109 40.5429 43.7094 42.5443 41.248 42.5444H35.2344C34.9395 42.5444 34.6993 42.3051 34.6992 42.0103C34.6992 41.7153 34.9394 41.4751 35.2344 41.4751H41.248C43.1195 41.475 44.6416 39.953 44.6416 38.0815C44.6415 36.2102 43.1194 34.6881 41.248 34.688H39.8535C39.5587 34.688 39.3185 34.4486 39.3184 34.1538C39.3184 33.8589 39.5586 33.6187 39.8535 33.6187H41.248Z",
    fill: "#0D4248",
    stroke: "#0D4248",
    strokeWidth: 0.335307
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3682 30.8354C34.2128 30.8355 34.8965 31.5221 34.8965 32.3638C34.8964 33.2082 34.2126 33.892 33.3682 33.8921C32.5237 33.8921 31.8399 33.2083 31.8398 32.3638C31.8398 31.5192 32.5236 30.8354 33.3682 30.8354ZM33.3682 31.8042C33.0607 31.8042 32.8086 32.0563 32.8086 32.3638C32.8086 32.6712 33.0607 32.9233 33.3682 32.9233C33.6756 32.9233 33.9277 32.6712 33.9277 32.3638C33.9277 32.0563 33.6756 31.8043 33.3682 31.8042Z",
    fill: "#0D4248",
    stroke: "#0D4248",
    strokeWidth: 0.234715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1143 34.4126C37.9587 34.4126 38.6426 35.0964 38.6426 35.9409C38.6425 36.7854 37.9587 37.4692 37.1143 37.4692C36.2696 37.4692 35.586 36.7826 35.5859 35.9409C35.5859 35.0964 36.2697 34.4126 37.1143 34.4126ZM37.1143 35.3813C36.8068 35.3813 36.5547 35.6334 36.5547 35.9409C36.5547 36.2484 36.8068 36.5005 37.1143 36.5005C37.4217 36.5004 37.6738 36.2483 37.6738 35.9409C37.6738 35.6334 37.4217 35.3814 37.1143 35.3813Z",
    fill: "#0D4248",
    stroke: "#0D4248",
    strokeWidth: 0.234715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5713 30.9937C36.7227 30.8282 36.9766 30.7865 37.1758 30.9048C37.4045 31.0408 37.479 31.3401 37.3438 31.5679H37.3428L33.9678 37.231L33.9668 37.2319C33.8752 37.3799 33.7162 37.4662 33.5518 37.4663C33.4899 37.4663 33.4261 37.4538 33.3652 37.4282L33.3057 37.3979C33.0768 37.262 33.0025 36.9637 33.1377 36.7358L36.5127 31.0728L36.5713 30.9937Z",
    fill: "#0D4248",
    stroke: "#0D4248",
    strokeWidth: 0.234715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7676 40.3315C34.7524 40.3315 35.5546 41.1339 35.5547 42.1187C35.5547 43.1035 34.7524 43.9058 33.7676 43.9058C32.7828 43.9057 31.9805 43.1034 31.9805 42.1187C31.9805 41.1339 32.7829 40.3316 33.7676 40.3315ZM33.7676 41.3003C33.3147 41.3004 32.9493 41.668 32.9492 42.1187C32.9492 42.5691 33.3171 42.9379 33.7676 42.938C34.2181 42.938 34.5869 42.5692 34.5869 42.1187C34.5868 41.6682 34.218 41.3003 33.7676 41.3003Z",
    fill: "#0D4248",
    stroke: "#0D4248",
    strokeWidth: 0.234715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4531 24.7144C35.7481 24.7144 35.9883 24.9546 35.9883 25.2495C35.9881 25.5443 35.748 25.7837 35.4531 25.7837H29.4395C27.5681 25.7838 26.046 27.3059 26.0459 29.1772C26.0459 31.0487 27.568 32.5707 29.4395 32.5708H30.835C31.1297 32.571 31.3691 32.8112 31.3691 33.106C31.369 33.4007 31.1296 33.6399 30.835 33.6401H29.4395C26.9782 33.64 24.9766 31.6386 24.9766 29.1772C24.9767 26.716 26.9782 24.7145 29.4395 24.7144H35.4531Z",
    fill: "#0D4248",
    stroke: "#0D4248",
    strokeWidth: 0.335307
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9238 23.3535C37.9086 23.3535 38.7109 24.1559 38.7109 25.1406C38.7109 26.1254 37.9087 26.9277 36.9238 26.9277C35.9391 26.9277 35.1367 26.1254 35.1367 25.1406C35.1368 24.1559 35.9391 23.3536 36.9238 23.3535ZM36.9238 24.3223C36.4734 24.3223 36.1055 24.6902 36.1055 25.1406C36.1055 25.5911 36.4734 25.9599 36.9238 25.96C37.3768 25.96 37.7432 25.5913 37.7432 25.1406C37.7431 24.6902 37.3743 24.3223 36.9238 24.3223Z",
    fill: "#0D4248",
    stroke: "#0D4248",
    strokeWidth: 0.234715
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9184_6951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6573,
    height: 23.5666,
    fill: "white",
    transform: "translate(23.1914 20.9087)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditHistoryIcon);
export default __webpack_public_path__ + "static/media/credit-history-icon.1455e932f745e036aec11aa963b3638d.svg";
export { ForwardRef as ReactComponent };